<template>
  <div class="main">
    <base-card v-for="sandwich in sandwiches" :key="sandwich.name" class="card">
      <v-card-title>{{ sandwich.name }}</v-card-title>
      <v-card-text>{{ sandwich.text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        {{ sandwich.price }}
      </v-card-actions>
    </base-card>
    <base-card color="#DC143C">
      <v-card-title class="flex text-center">Sanduiç i ftohtë</v-card-title>
    </base-card>
    <base-card v-for="sub in subs" :key="sub.name">
      <v-card-title>{{ sub.name }}</v-card-title>
      <v-card-text>{{ sub.text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        {{ sub.price }}
      </v-card-actions>
    </base-card>
    <base-card color="#DC143C">
      <v-card-title class="flex text-center">Pomfrit</v-card-title>
    </base-card>
    <base-card>
      <v-card-title>Pomfrit</v-card-title>
      <v-card-actions class="flex text-right">
        <v-spacer></v-spacer>
        I vogël 60 den. <br />
        I madh 80 den.
      </v-card-actions>
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sandwiches: [
        {
          name: "Lepinje dhe pleskavicë",
          text: "Lepinje, pleskavic",
          price: "130 den.",
        },
        {
          name: "Hamburger",
          text: "Lepinje, pleskavic, pomfrit, sallatë ",
          price: "160 den.",
        },
        {
          name: "Cheeseburger",
          text: "Lepinje, pleskavic, kaçkavall, pomfrit, sallatë",
          price: "190 den.",
        },
        {
          name: "Sivi",
          text: "Lepinje, pomfrit, sallatë",
          price: "120 den.",
        },
        {
          name: "Lepinje, stek pule",
          text: "Lepinje, stek pule, sallatë",
          price: "150 den.",
        },
        {
          name: "Stek pule",
          text: "Lepinje, stek pule, pomfrit, sallatë",
          price: "180 den.",
        },
        {
          name: "Crispy Chicken",
          text: "Lepinje, stek pule me shtojca, pomfrit, sallatë",
          price: "200 den.",
        },
        {
          name: "EKSTRA CHICKEN",
          text: "Lepinje, stek pule, kaçkavall, pomfrit, sallatë",
          price: "210 den.",
        },
        {
          name: "Frëngjisht",
          text: "Lepinje franceze, sallamë pule, kaçkavall, pomfrit, sallatë",
          price: "150 den.",
        },
        {
          name: "Кombinuar",
          text: "Lepinje, sallamë pule, kaçkavall, pomfrit, sallatë",
          price: "160 den.",
        },
        {
          name: "Vegjetarian",
          text: "Lepinje, kaçkavall, kërpudha, pomfrit, sallatë",
          price: "150 den.",
        },
        {
          name: "Hot dog",
          text: "Lepinje, salçiçe, senf",
          price: "80 den.",
        },
        {
          name: "Hot dog i dyfishtë",
          text: "Lepinje, 2 salçiçe, senf",
          price: "100 den.",
        },
        {
          name: "Hot dog 'Woody'",
          text: "Lepinje, salçiçe 'Woody', senf",
          price: "110 den.",
        },
        {
          name: "Hot dog i dyfishtë 'Woody'",
          text: "Lepinje, 2 salçiçe 'Woody', senf",
          price: "140 den.",
        },
        {
          name: "Hot dog 'Woody' dhe pomfrit",
          text: "Lepinje, salçiçe 'Woody, pomfrit, senf",
          price: "150 den.",
        },
        {
          name: "Hot dog i dyfishtë 'Woody' dhe pomfrit",
          text: "Lepinje, 2 salçiçe 'Woody', pomfrit, senf",
          price: "180 den.",
        },
        {
          name: "Sanduiç 1 salsiçe",
          text: "Lepinje, 1 salçiçe, pomfrit, sallatë, senf",
          price: "120 den.",
        },
        {
          name: "Sanduiç 2 salsiçe",
          text: "Lepinje, 2 salçiçe, pomfrit, sallatë, senf",
          price: "140 den.",
        },

      ],
      subs: [
        {
          name: "Pule sanduiç",
          text: "Lepinje, sallatë pule, ajkë, marule",
          price: "100 den.",
        },
        {
          name: "Chicken",
          text: "Lepinje, sallamë pule, kaçkavall, sallatë",
          price: "110 den.",
        },
        {
          name: "Kulen sanduiç",
          text: "Lepinje, kulen, kaçkavall, sallatë",
          price: "130 den.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.main {
  min-height: 300vh;
  background: transparent;
}
</style>
